import { render } from "./Links.vue?vue&type=template&id=9749f0e4&scoped=true"
import script from "./Links.vue?vue&type=script&lang=js"
export * from "./Links.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-9749f0e4"

export default script